// 小屏-门禁
<template>
  <div class="DkbSAccess">
    <div class="recordArea">
      <p class="tit">人脸门禁识别记录</p>
      <div class="li listTit">
        <p class="No">序号</p>
        <p class="name">姓名</p>
        <p class="time">识别时间</p>
      </div>
      <div class="recordList DkbScroll">
        <div class="li" v-for="(item, index) in sData.RecordList" :key="index">
          <p class="No">{{index+1}}</p>
          <p class="name">{{item.Name}}</p>
          <p class="time">{{item.Time}}</p>
        </div>
      </div>
    </div>
    <div class="caseArea">
      <p class="tit">今日访客预约情况</p>
      <div class="caseList DkbScroll">
        <div class="li" v-for="(item, index) in sData.CaseList" :key="index">
          <img class="img" :src="item.ImgUrl" alt="">
          <div class="info">
            <p class="person">预约人：{{item.Name}}</p>
            <p class="num">预约人数：{{item.Num}}</p>
            <p class="time">预约时间：{{item.Time}}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { dkbApi } from "../../../../static/js/dkb/dkb.js"
  import { showToast } from "../../../../static/js/utility/utility.js"
  let vm, rTimer, cTimer

  export default {
    name: 'DkbSAccess',
    components: {
    },
    props: {
      // 父组件传来的参数
      sData: {
        type: Object,
        default: {}
      }
    },
    computed: {
    },
    data () {
      return {
      }
    },
    created () {
      vm = this
    },
    mounted() {
      // console.log('route', this.$route)
      vm.timeRefresh()
    },
    destroyed () {
      clearInterval(rTimer)
      clearInterval(cTimer)
    },
    methods: {
      // 定时刷新数据
      timeRefresh () {
        rTimer = setInterval(()=>{
          vm.GetAccessRecord()
        }, 1000*5)
        cTimer = setInterval(()=>{
          vm.GetAccessCase()
        }, 1000*5*60)
      },
      // 获取人脸门禁识别记录（小屏）
      async GetAccessRecord () {
        let res = await dkbApi.GetAccessRecord()
        if (res.ErrCode === 0) {
          vm.sData.RecordList = res.Result
        } else {
          showToast(res.meta.ErrMsg)
        }
      },
      // 获取门禁访客预约情况（小屏）
      async GetAccessCase () {
        let res = await dkbApi.GetAccessCase()
        if (res.ErrCode === 0) {
          vm.sData.CaseList = res.Result
        } else {
          showToast(res.meta.ErrMsg)
        }
      },
    },
    watch: {
    }
  }
</script>

<style lang="scss" scoped>
.DkbSAccess {
  width: 100%;
  height: 100%;
  padding:  0 0.49rem 0.4rem 0.68rem;
  display: flex;
  justify-content: space-between;
  .tit {
    font-size: 0.15rem;
    text-align: center;
    margin: 0.2rem 0 0.12rem;
  }
  .recordArea {
    width: 2.27rem;
    height: 100%;
    display: flex;
    flex-direction: column;
    .li.listTit {
      height: 0.34rem;
      line-height: 0.34rem;
      margin-right: 0;
    }
    .li {
      margin-right: 0.02rem;
      font-size: 0.12rem;
      line-height: 0.24rem;
      text-align: center;
      background-color: #072c4e;
      display: flex;
      .No {
        flex-shrink: 0;
        width: 0.33rem;
        margin-left: 0.16rem;
      }
      .name {
        flex-shrink: 0;
        width: 0.5rem;
      }
      .time {
        flex-shrink: 0;
        width: 1rem;
      }
    }
    .recordList {
      width: 100%;
      max-height: 100%;
      // height: 100%;
      // background-color: #072c4e;
      overflow-x: hidden;
      overflow-y: scroll;
      .li:nth-child(odd) {
        background-color: #103b5c;
      }
    }
  }
  .caseArea {
    width: 2.44rem;
    height: 100%;
    display: flex;
    flex-direction: column;
    .caseList {
      max-height: 100%;
      overflow-x: hidden;
      overflow-y: scroll;
      .li {
        margin-right: 0.02rem;
        padding: 0.15rem 0 0.25rem;
        background-color: #072c4e;
        display: flex;
        align-items: center;
        .img {
          width: 0.52rem;
          height: 0.52rem;
          margin: 0 0.1rem 0 0.15rem;
        }
        .info {
          font-size: 0.12rem;
          line-height: 0.22rem;
        }
      }
      .li+.li {
        padding-top: 0;
      }
      .li:last-child {
        padding-bottom: 0.15rem;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/DkbPage/SScreen/Access.vue